
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { featuredContent, catalogItems, reviews } from '../../mocks/content';

const HomePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isLive] = useState(true);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % featuredContent.slice(0, 3).length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + featuredContent.slice(0, 3).length) % featuredContent.slice(0, 3).length);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen overflow-hidden">
        <div className="absolute inset-0">
          {featuredContent.slice(0, 3).map((item, index) => (
            <div
              key={item.id}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <div className="w-full h-full">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black"></div>
            </div>
          ))}
        </div>

        <div className="relative h-full max-w-7xl mx-auto px-6 flex items-center">
          <div className="w-full grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
            {/* Left Content */}
            <div className="lg:col-span-3 space-y-8">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                <h1 className="text-7xl lg:text-8xl font-black text-white leading-tight tracking-wide">
                  {featuredContent[currentSlide].title}
                </h1>
              </motion.div>

              <motion.p
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="text-xl text-gray-300 font-light max-w-2xl"
              >
                {featuredContent[currentSlide].description}
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                className="flex flex-wrap gap-4"
              >
                <Link
                  to="/catalogo"
                  className="px-8 py-4 bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500 text-white rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-pink-500/50 transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Explorar Catálogo
                </Link>
                <Link
                  to="/en-vivo"
                  className="px-8 py-4 bg-white/10 backdrop-blur-md border-2 border-white/30 text-white rounded-full font-bold text-lg hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Ver Transmisión
                </Link>
              </motion.div>

              {/* Slider Controls */}
              <div className="flex items-center space-x-4">
                <button
                  onClick={prevSlide}
                  className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white/20 transition-all duration-300 cursor-pointer"
                  aria-label="Previous"
                >
                  <i className="ri-arrow-left-s-line text-2xl"></i>
                </button>
                <button
                  onClick={nextSlide}
                  className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white hover:bg-white/20 transition-all duration-300 cursor-pointer"
                  aria-label="Next"
                >
                  <i className="ri-arrow-right-s-line text-2xl"></i>
                </button>
                <div className="flex space-x-2">
                  {featuredContent.slice(0, 3).map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                        index === currentSlide ? 'w-8 bg-pink-500' : 'bg-white/30'
                      }`}
                      aria-label={`Slide ${index + 1}`}
                    ></button>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Content - Live Stream Preview */}
            {isLive && (
              <div className="lg:col-span-2">
                <motion.div
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, delay: 0.6 }}
                  className="relative rounded-2xl overflow-hidden bg-black/40 backdrop-blur-md border border-white/20"
                >
                  <div className="absolute top-4 right-4 z-10">
                    <div className="flex items-center space-x-2 px-4 py-2 bg-red-500 rounded-full">
                      <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                      <span className="text-white text-sm font-bold uppercase">EN VIVO</span>
                    </div>
                  </div>
                  <div className="w-full h-full aspect-video">
                    <img
                      src="https://public.readdy.ai/ai/img_res/da7b1cd3169cd09cc30d1cc1486b52db.jpg"
                      alt="Live Stream"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300 bg-black/60">
                    <Link
                      to="/en-vivo"
                      className="w-16 h-16 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-md border-2 border-white text-white hover:scale-110 transition-transform duration-300 cursor-pointer"
                    >
                      <i className="ri-play-fill text-3xl"></i>
                    </Link>
                  </div>
                  <div className="p-4 bg-gradient-to-t from-black/80 to-transparent">
                    <p className="text-white font-bold text-lg">Transmisión en Vivo</p>
                    <p className="text-gray-300 text-sm">Únete ahora y disfruta del contenido</p>
                  </div>
                </motion.div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Featured Catalog */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-12">
            <h2 className="text-5xl font-black text-white">
              Contenido <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-cyan-500">Destacado</span>
            </h2>
            <Link
              to="/catalogo"
              className="text-gray-300 hover:text-pink-500 transition-colors flex items-center space-x-2 cursor-pointer"
            >
              <span>Ver todo</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {catalogItems.slice(0, 10).map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                <div className="w-full aspect-[2/3]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4 space-y-2">
                    <h3 className="text-white font-bold text-lg">{item.title}</h3>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-gray-300">{item.year}</span>
                      <span className="text-gray-300">{item.genre}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={`ri-star-${i < Math.floor(item.rating) ? 'fill' : 'line'} text-yellow-400 text-sm`}
                        ></i>
                      ))}
                      <span className="text-white text-sm ml-2">{item.rating}</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Recommendations */}
      <section className="py-24 px-6 bg-gradient-to-b from-transparent via-purple-900/10 to-transparent">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <h2 className="text-5xl font-black text-white mb-4">
              Recomendaciones <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-pink-500">Personalizadas</span> 🎯
            </h2>
            <p className="text-gray-400 text-lg">Basadas en tus preferencias</p>
          </div>

          <div className="relative">
            <div className="flex space-x-6 overflow-x-auto pb-4 scrollbar-hide">
              {featuredContent.map((item, index) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, x: 30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex-shrink-0 w-72 group cursor-pointer"
                >
                  <div className="relative rounded-2xl overflow-hidden shadow-2xl transform group-hover:scale-105 transition-all duration-300">
                    <div className="w-full h-72">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="absolute top-4 right-4">
                      <div className="w-14 h-14 flex items-center justify-center rounded-full bg-green-500 border-4 border-white shadow-lg">
                        <span className="text-white font-black text-sm">{item.match}%</span>
                      </div>
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-6 space-y-2">
                      <h3 className="text-white font-bold text-xl">{item.title}</h3>
                      <div className="flex items-center space-x-3 text-sm text-gray-300">
                        <span>{item.type}</span>
                        <span>•</span>
                        <span>{item.genre}</span>
                        <span>•</span>
                        <span>{item.year}</span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-black text-white mb-4">
              Reseñas <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-500">Destacadas</span>
            </h2>
            <p className="text-gray-400 text-lg">Lo que dicen nuestros críticos</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {reviews.map((review, index) => (
              <motion.div
                key={review.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                viewport={{ once: true }}
                className="bg-gradient-to-br from-gray-900 to-black rounded-2xl overflow-hidden border border-white/10 hover:border-pink-500/50 transition-all duration-300 shadow-2xl"
              >
                <div className="w-full h-64">
                  <img
                    src={review.image}
                    alt={review.contentTitle}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 space-y-4">
                  <div className="flex items-center space-x-1">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                    ))}
                  </div>
                  <h3 className="text-white font-bold text-xl">{review.contentTitle}</h3>
                  <p className="text-gray-300 text-sm leading-relaxed line-clamp-4">
                    "{review.text}"
                  </p>
                  <div className="pt-4 border-t border-white/10">
                    <p className="text-white font-semibold">{review.reviewer}</p>
                    <p className="text-gray-400 text-sm">{review.role}</p>
                    <p className="text-gray-500 text-xs mt-1">{review.date}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-6">
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative rounded-3xl overflow-hidden bg-gradient-to-r from-pink-500 via-purple-500 to-cyan-500 p-1"
          >
            <div className="bg-black rounded-3xl p-12 text-center space-y-6">
              <h2 className="text-5xl font-black text-white">
                ¿Quieres Anunciar con Nosotros?
              </h2>
              <p className="text-gray-300 text-lg max-w-2xl mx-auto">
                Llega a miles de amantes del entretenimiento. Contacta con nosotros para publicidad personalizada y efectiva.
              </p>
              <Link
                to="/contacto"
                className="inline-flex items-center space-x-2 px-8 py-4 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full font-bold text-lg hover:shadow-2xl hover:shadow-pink-500/50 transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span>Contactar Ahora</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
